import useSWRImmutable from 'swr/immutable';
import settings from '/@/core/settings';
import { axFetch } from '/@/store/session/actions';

export const getBrandsFromApi = async ({
    page,
    pageSize = 10,
    country,
    type,
    codename,
}: {
    page: number;
    pageSize?: number;
    country?: string;
    type?: string;
    codename?: string;
}) => {
    const apiUrl = new URL(`${settings.urls.apiDomain}/core/v1/catalog/brands/`, window.location.origin);

    const params = new URLSearchParams();
    params.append('page', String(page));
    params.append('page_size', String(pageSize));
    if (codename) params.append('codename', String(codename));
    if (country) params.append('country', String(country));
    if (type) params.append('type', String(type));
    apiUrl.search = params.toString();

    const res = await axFetch.get(apiUrl.toString());
    return res.data;
};

export const useBrands = ({
    page,
    pageSize = 10,
    country,
    type,
    codename,
}: {
    page: number;
    pageSize?: number;
    country?: string;
    type?: string;
    codename?: string;
}) => {
    const key = { key: 'useBrands', page, pageSize, codename, country, type };
    return useSWRImmutable(key, getBrandsFromApi);
};
